export default "__VITE_ASSET__Bz_cSJ91__"